'use client'

import Script from 'next/script'

import { env } from '@/config/env'

/**
 * Only works on HTTPS, so not testable locally (https://help.hotjar.com/hc/en-us/articles/115011624047-Does-Hotjar-Track-All-Your-Users)
 *
 * @see https://zippystarter.com/blog/blog-starter/integrate-hotjar-with-nextjs
 */
export function HotjarInit() {
  if (env('NODE_ENV') !== 'production') return null

  return (
    <Script id="hotjar">
      {`
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${env('NEXT_PUBLIC_HOTJAR_ID')},hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
      `}
    </Script>
  )
}
